export const PENDING_PIN = 'pending_pin'

const MESSAGE = 'Validez ou annulez le point en cours de placement avant d\'enregistrer.'

// A point being placed lives in the field's local state only, so saving would drop it silently.
export const pendingPinErrors = marks => Object.fromEntries(
  marks
    .filter(mark => mark[PENDING_PIN])
    .map(mark => [`marks[${mark.id}]`, { base: [MESSAGE] }])
)

export const pendingPinErrorsByParallel = parallels => parallels.reduce((errors, parallel) => {
  const markErrors = pendingPinErrors(parallel.marks)
  if (Object.keys(markErrors).length === 0)
    return errors
  return { ...errors, [`parallels[${parallel.id}]`]: markErrors }
}, {})
